import { Component, OnInit } from '@angular/core';
import { TaskManagerStateService } from './service/taskmanager-state.service';
import { Router } from '@angular/router';



@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false ,  // NOSONAR
})
export class AppComponent implements OnInit {
	title = 'LIOS Task manager';

	isAuthorized: boolean = false;
	AUthToken: boolean = false;
	clientHeight: number;

	constructor(private readonly state: TaskManagerStateService, private readonly router: Router) {
		this.clientHeight = window.innerHeight;
	}

	ngOnInit() {


		if (localStorage.getItem('toyotaGUID')) {
			this.AUthToken = true;
		}

		// debugger
		this.state.roleState.subscribe((value) => {
			if (value) {
				this.isAuthorized = true;
			}
		});

		this.router.navigate(['/board']);
	}
}
